<script>
    import { getContext } from "svelte";
    import { key } from "../context/cinemaTileDimension";
    import { key as add2BasketButtonCtxKey } from "../context/add2BasketButton.js";
    import { key as featureStateRuleCtxKey } from "../context/featureState.js";
    import Add2BasketButton from "./Add2BasketButton.svelte";
    import OfcPrice from "./OfcPrice.svelte";
    import TopInfo from "./TopInfo.svelte";
    import Price from "./Price.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        brandName,
        variation,
        pricing,
        deal = {},
        showTopInfo = false,
        widgetAdditionalClickTracking,
        additionalClickTracking,
        trackAdd2BasketVisibility,
    } = $props();

    const showAddToBasketButton = getContext(add2BasketButtonCtxKey)?.showAddToBasketButton;
    const tileDimensions = getContext(key);
    const showNewPriceComponent = getContext(featureStateRuleCtxKey)?.ENABLE_NEW_PRICE_COMPONENT;
</script>

<div style:width={`${tileDimensions.width}px`} class="reco_cinema__information-container">
    <div class="reco_cinema__brand oc-copy-75">
        {brandName}
    </div>
    <div class="reco_cinema__name oc-copy-100">
        {variation.name}
    </div>
    {#if showAddToBasketButton}
        <div class="oc-mt-50 oc-mb-50">
            <Add2BasketButton
                variationId={variation.id}
                {widgetAdditionalClickTracking}
                {additionalClickTracking}
                {trackAdd2BasketVisibility}
            />
        </div>
    {/if}
    {#if showTopInfo}
        <div data-testid="product_top_info">
            <TopInfo {variation} />
        </div>
    {/if}

    {#if showNewPriceComponent}
        <OfcPrice rawPricing={variation.pricing} {deal} variationId={variation.id} />
    {:else}
        <Price {pricing} highlightText={variation.highlightText} />
    {/if}
</div>

<style lang="scss">
    :root {
        --padding_within_cell: 8px;
    }

    .reco_cinema__brand {
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .reco_cinema__information-container {
        text-align: left;
        overflow: hidden;
        max-width: 100%;
        margin-top: 8px;
    }

    .reco_cinema__name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
